import type { ChromeStrings } from './en';

/** Arabic chrome strings (RTL). Mirrors the EN catalog keys. */
const ar: ChromeStrings = {
  app: {
    title: 'لوحة Y/DIRECTION',
    edition: 'وكالة الأسئلة',
    primaryNav: 'التنقل الرئيسي',
    toggleNav: 'تبديل قائمة التنقل',
  },
  nav: {
    dashboard: 'لوحة المعلومات',
    content: 'المحتوى',
    pages: 'الصفحات',
    fieldNotes: 'رؤى',
    services: 'الخدمات',
    caseStudies: 'دراسات الحالة',
    packages: 'الباقات',
    clients: 'العملاء',
    testimonials: 'الشهادات',
    productFamilies: 'عائلات المنتجات',
    industries: 'القطاعات',
    projects: 'المشاريع',
    articles: 'المقالات',
    jobPostings: 'الوظائف',
    products: 'المنتجات',
    locations: 'المواقع',
    subsidiaries: 'الشركات التابعة',
    siteAssets: 'أصول الموقع',
    teamMembers: 'أعضاء الفريق',
    media: 'مكتبة الوسائط',
    leads: 'العملاء المحتملون',
    contact: 'مكالمات استكشافية',
    quotes: 'طلبات عروض الأسعار',
    applications: 'طلبات التوظيف',
    newsletter: 'النشرة البريدية',
    revisions: 'المراجعات',
    administration: 'الإدارة',
    users: 'المستخدمون',
    settings: 'إعدادات الموقع',
    audit: 'سجل التدقيق',
    search: 'بحث',
    account: 'الحساب',
    signOut: 'تسجيل الخروج',
  },
  common: {
    save: 'حفظ',
    saveDraft: 'حفظ كمسودة',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    confirm: 'تأكيد',
    ok: 'حسنًا',
    retry: 'إعادة المحاولة',
    reset: 'إعادة تعيين',
    publish: 'نشر',
    unpublish: 'إلغاء النشر',
    schedule: 'جدولة',
    preview: 'معاينة',
    status: 'الحالة',
    title: 'العنوان',
    slug: 'المعرف',
    key: 'المفتاح',
    namespaces: 'النطاقات',
    updated: 'آخر تحديث',
    created: 'تاريخ الإنشاء',
    actions: 'إجراءات',
    loading: 'جارٍ التحميل',
    search: 'بحث',
    filters: 'عوامل التصفية',
    clear: 'مسح',
    all: 'الكل',
    none: 'لا شيء',
    en: 'الإنجليزية',
    ar: 'العربية',
    lastSaved: 'آخر حفظ {{time}}',
    siteWillUpdate: 'تم الحفظ. سيتم تحديث الموقع العام قريبًا.',
    permissionDenied: 'ليس لديك إذن للقيام بذلك.',
    missingArabic: 'العربية غير مكتملة',
    arComplete: 'العربية مكتملة',
  },
  auth: {
    signIn: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    totp: 'رمز المصادقة',
    totpHint: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة.',
    forgot: 'هل نسيت كلمة المرور؟',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotNeutral: 'إذا كان هناك حساب بهذا البريد، فستتلقى تعليمات إعادة التعيين.',
    resetTitle: 'اختر كلمة مرور جديدة',
    newPassword: 'كلمة المرور الجديدة',
    locked: 'هذا الحساب مقفل مؤقتًا. حاول مرة أخرى لاحقًا.',
    rateLimited: 'محاولات كثيرة جدًا. يرجى الانتظار قليلًا ثم المحاولة مرة أخرى.',
    invalid: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    invalidTotp: 'رمز المصادقة غير صحيح. حاول مرة أخرى.',
    totpRequired: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة للمتابعة.',
    eyebrowSignIn: 'المسؤول · تسجيل الدخول',
    eyebrowReset: 'المسؤول · إعادة التعيين',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    resetInvalid: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. اطلب رابطًا جديدًا.',
    setNewPassword: 'تعيين كلمة مرور جديدة',
  },
  ui: {
    nothingHereYet: 'لا يوجد شيء هنا بعد',
    noResults: 'لا توجد نتائج',
    somethingWentWrong: 'حدث خطأ ما.',
    error: 'خطأ',
    reportThis: 'الإبلاغ عن ذلك',
    readOnlyAccess: 'لديك صلاحية الاطلاع فقط على هذا القسم.',
    paginationSummary: '<from>{{from}}</from>–<to>{{to}}</to> من <total>{{total}}</total>',
    perPage: 'لكل صفحة',
    prev: 'السابق',
    next: 'التالي',
    previousPage: 'الصفحة السابقة',
    nextPage: 'الصفحة التالية',
    close: 'إغلاق',
    typeToConfirm: 'اكتب "{{phrase}}" للتأكيد',
    selectPlaceholder: 'اختر…',
    selectAllRows: 'تحديد كل الصفوف',
    selectRow: 'تحديد الصف {{id}}',
    crashTitle: 'حدثت مشكلة في هذا العرض',
    crashBody: 'لم تتأثر بقية لوحة التحكم. حاول مرة أخرى أو أعد تحميل الصفحة.',
    reload: 'إعادة التحميل',
  },
  status: {
    content: {
      draft: 'مسودة',
      in_review: 'قيد المراجعة',
      scheduled: 'مجدول',
      published: 'منشور',
      archived: 'مؤرشف',
    },
    lead: {
      new: 'جديد',
      in_progress: 'قيد المعالجة',
      reviewing: 'قيد المراجعة',
      shortlisted: 'في القائمة المختصرة',
      responded: 'تم الرد',
      hired: 'تم التوظيف',
      rejected: 'مرفوض',
      closed: 'مغلق',
      spam: 'بريد مزعج',
      archived: 'مؤرشف',
    },
    newsletter: {
      confirmed: 'مؤكد',
      pending_confirmation: 'بانتظار التأكيد',
      unsubscribed: 'ملغى الاشتراك',
    },
  },
  forms: {
    remove: 'إزالة',
    addItem: '+ إضافة عنصر',
    addEntry: '+ إضافة مُدخل',
    mapKey: 'المفتاح',
    mapValue: 'القيمة',
    mapKeyDuplicate: 'مفتاح مكرر',
    item: 'العنصر {{n}}',
    indexLabel: '#{{n}}',
    rawHint: 'احتياطي بصيغة JSON الخام. يتم التحقق منه عند الحفظ.',
    rawLabel: '{{name}} (خام)',
    choose: 'اختيار',
    noMediaSelected: 'لم يتم اختيار وسائط',
    noEntitySelected: 'لم يتم اختيار مرجع {{collection}}',
    fieldEnglish: '{{label}} (الإنجليزية)',
    fieldArabic: '{{label}} (العربية)',
    refNone: 'لم يتم الاختيار',
    refMissing: '{{value}} (غير موجود)',
    noFields: 'لا توجد حقول قابلة للتهيئة.',
  },
  governance: {
    arCoverage: 'تغطية اللغة العربية',
    noTranslatableFields: 'لا يوجد نص قابل للترجمة بعد',
    coverageCount: '{{translated}} / {{total}} مترجَم',
    arabicComplete: 'الترجمة العربية مكتملة',
    arabicCompleteHintReady: 'جميع الحقول القابلة للترجمة تحتوي على نص عربي.',
    arabicCompleteHintPending: '{{count}} حقل/حقول ما زالت بدون ترجمة عربية.',
    arabicCompleteGate: 'حتى يتم تفعيل هذا، قد يُمنع النشر لتجنّب عرض صفحة نصفها مترجَم.',
    publishBlockedAr: 'تعذّر النشر: المحتوى العربي غير مكتمل.',
    publishBlockedArDetail: 'أكمل الترجمة العربية وفعّل "الترجمة العربية مكتملة"، ثم انشر.',
  },
  vocab: {
    block: {
      paragraph: 'فقرة',
      subheading: 'عنوان فرعي',
      list: 'قائمة',
      pullquote: 'اقتباس مميّز',
      aside: 'حاشية',
      figure: 'صورة',
    },
    layer: {
      core: 'أساسية',
      addon: 'إضافية',
    },
    clientType: {
      external: 'خارجي',
      groupBrand: 'علامة المجموعة',
    },
    teamGroup: {
      founders: 'المؤسِّسون',
      team: 'فريقنا',
    },
    topic: {
      strategy: 'الاستراتيجية',
      branding: 'العلامة التجارية',
      socialPaid: 'التواصل والإعلانات المدفوعة',
      craftAi: 'الحِرفة والذكاء الاصطناعي',
    },
  },
  dashboard: {
    eyebrow: 'لوحة التحكم',
    title: 'نظرة تشغيلية عامة',
    pages: 'الصفحات',
    contentByCollection: 'المحتوى حسب المجموعة',
    leads: 'العملاء المحتملون',
    recentActivity: 'النشاط الأخير',
    total: 'الإجمالي',
    published: 'منشور',
    draft: 'مسودة',
    media: 'الوسائط',
    newCount: '{{count}} جديد',
    ofPublished: '/ {{total}} منشور',
    totalSuffix: 'الإجمالي',
    systemActor: 'النظام',
  },
  activity: {
    action: {
      login: 'سجّل الدخول',
      logout: 'سجّل الخروج',
      create: 'أنشأ',
      update: 'حدّث',
      delete: 'حذف',
      publish: 'نشر',
      unpublish: 'ألغى النشر',
    },
    entity: {
      user: 'مستخدم',
      page: 'صفحة',
      section: 'قسم',
      family: 'عائلة منتجات',
      product_family: 'عائلة منتجات',
      media: 'ملف وسائط',
      industry: 'قطاع',
      project: 'مشروع',
      article: 'مقال',
      job: 'وظيفة شاغرة',
      product: 'منتج',
      location: 'موقع',
      subsidiary: 'شركة تابعة',
      setting: 'إعداد',
    },
  },
  content: {
    unknownCollection: 'مجموعة غير معروفة.',
    newItem: 'عنصر جديد',
    newItemPermission: 'يتطلب صلاحية لإنشاء المحتوى أو تعديله.',
    order: 'الترتيب',
    arShort: 'ع',
    missingAr: 'العربية ناقصة',
    selected: 'محدد',
    publishPermission: 'يتطلب صلاحية النشر.',
    deletePermission: 'يتطلب صلاحية الحذف.',
    bulkResult: '{{action}}: نجح {{succeeded}}، وفشل {{failed}}.',
    bulkPartialFail: 'تعذّرت معالجة بعض العناصر. عدّل المعطيات وأعد المحاولة.',
    statusFilter: {
      all: 'كل الحالات',
      draft: 'مسودة',
      scheduled: 'مجدول',
      published: 'منشور',
      archived: 'مؤرشف',
    },
    newTitle: '{{label}} جديد',
    untitled: '(بدون عنوان)',
    editPermission: 'يتطلب صلاحية لتعديل المحتوى.',
    slugHint: 'يُولَّد تلقائيًا من العنوان الإنجليزي؛ يمكنك تعديله لتجاوزه.',
    sortOrder: 'ترتيب الفرز',
    contentTab: 'المحتوى',
    seoTab: 'تحسين محركات البحث',
    historyTab: 'السجل',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    siteUpdateBody: 'سيتم تحديث الموقع العام قريبًا.',
    publicationUpdated: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    unpublishRedirect: 'تُعيد الصفحة العامة الآن التوجيه إلى فهرس المجموعة.',
    filterAll: 'الكل',
    choose: 'اختر {{label}}',
    deleteItemTitle: 'حذف هذا العنصر؟',
    deleteItemDescription: 'سيُحذف هذا العنصر نهائيًا. لا يمكن التراجع عن هذا الإجراء.',
  },
  collections: {
    fieldNotes: { label: 'رؤى', singular: 'رؤية' },
    services: { label: 'الخدمات', singular: 'خدمة' },
    caseStudies: { label: 'دراسات الحالة', singular: 'دراسة حالة' },
    packages: { label: 'الباقات', singular: 'باقة' },
    clients: { label: 'العملاء', singular: 'عميل' },
    testimonials: { label: 'الشهادات', singular: 'شهادة' },
    industries: { label: 'القطاعات', singular: 'قطاع' },
    projects: { label: 'المشاريع', singular: 'مشروع' },
    articles: { label: 'المقالات / الرؤى', singular: 'مقال' },
    jobPostings: { label: 'الوظائف الشاغرة', singular: 'وظيفة شاغرة' },
    products: { label: 'المنتجات', singular: 'منتج' },
    locations: { label: 'المواقع', singular: 'موقع' },
    subsidiaries: { label: 'الشركات التابعة', singular: 'شركة تابعة' },
    siteAssets: { label: 'أصول الموقع', singular: 'أصل الموقع' },
    teamMembers: { label: 'الفريق', singular: 'عضو الفريق' },
  },
  fields: {
    // ── الملاحظات الميدانية (مجموعة Y/DIRECTION الوحيدة في الإصدار الأول) ──
    fieldNoteContent: 'ملاحظة ميدانية',
    fieldNoteCategoryHint: 'سطر علوي قصير فوق العنوان، مثل «في المنهج» أو «ملاحظة ميدانية».',
    excerptHint: 'جملة تشويقية واحدة تظهر على بطاقة فهرس الملاحظات الميدانية.',
    readingTime: 'وقت القراءة',
    readingTimeHint: 'يظهر على البطاقة والمقال، مثل «٦ دقائق».',
    displayDate: 'التاريخ المعروض',
    displayDateHint: 'تاريخ يُعرض للقرّاء، مثل «مارس 2026».',
    dateIso: 'التاريخ الآلي',
    dateIsoHint: 'تاريخ ISO للفرز والبيانات الوصفية، مثل 2026-03-14.',
    fieldNoteFeaturedHint: 'إبراز هذه الملاحظة في الفهرس وتشويقة الصفحة الرئيسية.',
    heroSrc: 'مسار الصورة',
    heroSrcHint: 'مسار أو رابط الصورة الرئيسية (يوفّر المحرّر المباشر منتقي وسائط).',
    width: 'العرض',
    height: 'الارتفاع',
    question: 'السؤال الافتتاحي',
    questionHint: 'السؤال الذي تفتتح به الملاحظة — صوت Y/DIRECTION.',
    arabicLine: 'سطر الهامش العربي',
    arabicLineHint: 'الحاشية العربية المكتوبة بخط اليد المقترنة بالسؤال.',
    lede: 'المقدّمة',
    ledeHint: 'الفقرة الاستهلالية أسفل السؤال.',
    authorName: 'اسم الكاتب',
    authorRole: 'صفة الكاتب',
    authorIsStudio: 'التوقيع باسم الوكالة',
    authorIsStudioHint: 'علّم عليه لما تكون Y/DIRECTION نفسها هي الكاتبة، مش شخص باسمه — وده الوضع الحالي للمقالات. ساعتها محرّكات البحث بتعرف إن المؤسّسة هي اللي كتبت. شيل العلامة واكتب اسم شخص حقيقي في «اسم الكاتب» لو عايز تنسب المقال ليه.',
    bodyBlock: 'كتلة',
    blockType: 'النوع',
    blockText: 'النص',
    blockTextHint: 'تستخدمه كتل الفقرة والعنوان الفرعي والاقتباس والحاشية.',
    blockItems: 'عناصر القائمة',
    blockAttribution: 'النسبة',
    blockAttributionHint: 'الجهة المنسوب إليها الاقتباس المميّز.',
    blockCaption: 'التعليق التوضيحي',
    bodyHint: 'متن المقال ككتل مرتّبة، يُحرَّر لكل لغة.',
    bodyEn: 'المتن (الإنجليزية)',
    bodyAr: 'المتن (العربية)',
    ctaPromise: 'الوعد',
    ctaSecondary: 'الزر الثانوي',
    ctaMarginNote: 'ملاحظة الهامش',
    finalCta: 'الدعوة الختامية',
    finalCtaHint: 'الدعوة الختامية لاتخاذ إجراء، وهي الخطوة التالية الوحيدة للملاحظة.',
    finalCtaEn: 'الدعوة الختامية (الإنجليزية)',
    finalCtaAr: 'الدعوة الختامية (العربية)',
    topic: 'الموضوع',
    topicHint: 'وسم موضوع اختياري قائم على المشكلة يستخدمه مرشّح فهرس الرؤى.',
    // ── مجموعات إعادة الهيكلة 2026 ───────────────────────────────────────
    serviceContent: 'خدمة',
    caseStudyContent: 'دراسة حالة',
    packageContent: 'باقة',
    clientContent: 'عميل',
    testimonialContent: 'شهادة',
    layer: 'الطبقة',
    layerHint: 'موضع هذه الخدمة في العرض — خدمة أساسية أو إضافية.',
    order: 'الترتيب',
    clientType: 'نوع العميل',
    typeLabel: 'تسمية النوع',
    context: 'السياق',
    challenge: 'التحدي',
    solution: 'الحل',
    deliverables: 'المخرجات',
    results: 'النتائج',
    resultPlaceholder: 'النتائج مؤقتة',
    idealFor: 'مناسب لـ',
    inclusions: 'ما تشمله',
    investment: 'الاستثمار',
    recommended: 'موصى به',
    ctaLabelField: 'نص الزر',
    website: 'الموقع الإلكتروني',
    caseStudySlug: 'معرّف دراسة الحالة',
    role: 'الدور',
    note: 'ملاحظة',
    open: 'وظيفة شاغرة',
    quote: 'الاقتباس',
    company: 'الشركة',
    placeholder: 'عنصر نائب',
    testimonial: 'شهادة',
    industry: 'القطاع',
    featured: 'مميَّز',
    category: 'التصنيف',
    department: 'القسم',
    graduate: 'خريج',
    family: 'العائلة',
    kind: 'النوع',
    industryContent: 'محتوى القطاع',
    projectContent: 'محتوى المشروع',
    articleContent: 'محتوى المقالة',
    jobPostingContent: 'محتوى الوظيفة الشاغرة',
    productContent: 'محتوى المنتج',
    locationContent: 'محتوى الموقع',
    isHq: 'المقر الرئيسي',
    isHqHint: 'يحدد هذا الموقع كمقر رئيسي — تُبرز بطاقته في صفحة التواصل.',
    locationTag: 'الوسم',
    locationTagHint: 'سطر علوي قصير فوق اسم المدينة، مثل «المقر الرئيسي · التصنيع».',
    address: 'العنوان',
    areaSqm: 'المساحة',
    areaSqmHint: 'اختياري، يظهر كشارة، مثل «36,000 م²».',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    hours: 'ساعات العمل',
    here: 'ما يوجد هنا',
    hereHint: 'وصف موجز للوظائف الموجودة في هذا المكتب.',
    subsidiaryContent: 'محتوى الشركة التابعة',
    subsidiaryTier: 'الفئة',
    subsidiaryTierHint: 'كيفية عرض هذا الكيان على الموقع: العلامة الأم، أو الشركة الرائدة في المملكة، أو شركة تابعة متخصّصة.',
    founded: 'سنة التأسيس',
    foundedHint: 'سنة التأسيس، مثل 2009.',
    subsidiaryInvestors: 'نص صفحة المستثمرين',
    subsidiaryAbout: 'نص صفحة من نحن',
    subsidiaryName: 'الاسم المعروض',
    subsidiaryFunction: 'الوظيفة',
    subsidiaryCategory: 'التصنيف',
    subsidiaryMeta: 'سطر التفاصيل',
    subsidiaryBody: 'النص',
    siteAssetContent: 'أصل الموقع',
    image: 'الصورة',
    imageHint: 'الصورة المعروضة لهذا العنصر على الموقع. استبدل الصورة المؤقتة برفع صورة حقيقية.',
    altText: 'النص البديل',
    teamMemberContent: 'عضو الفريق',
    teamGroup: 'المجموعة',
    teamGroupHint: 'القسم اللي بيظهر فيه العنصر ده على الموقع: المؤسِّسون أو الفريق.',
    teamRole: 'المنصب',
    teamRoleHint: 'المنصب أو اللقب، مثل: الاستراتيجية واتجاه العلامة. في حالة المؤسِّس اللي اسمه مش منشور، ده اللي بيظهر على الموقع بدل الاسم. سيبه فاضي في المقعد اللي لسه ما اتملاش — اسم الحرفة نفسه هو العنوان.',
    teamNoteHint: 'سطر قصير واحد عن اللي الشخص ده أو الحرفة دي بتعمله فعلًا. بيظهر تحت الاسم.',
    teamSeat: 'مقعد شاغر',
    teamSeatHint: 'علّم عليه لما يكون العنصر ده اسم حرفة مش اسم شخص. من غير صورة مرفوعة بيظهر بلا صورة، ومعاه سطر المقعد. شيل العلامة أول ما تكتب اسم حقيقي في العنوان — والعنصر بيترقّى لوحده.',
    teamSeatNote: 'سطر المقعد',
    teamSeatNoteHint: 'السطر الصريح اللي بيظهر على المقعد الشاغر، مثل: «هنكتب اسمه هنا أول ما المقعد يتملي». بيتجاهَل بعد ما المقعد يتملي.',
    teamUnnamed: 'الاسم مش منشور',
    teamUnnamedHint: 'علّم عليه لو ده شخص حقيقي لسه مش ناشرين اسمه — المؤسِّسون شغّالين كده دلوقتي. اكتب في العنوان الحاجة الصح («مؤسِّس») وحُطّ الحرفة في المنصب. بياخد صورة عادي، لأن في شخص فعلًا. شيل العلامة أول ما تنشر الاسم الحقيقي — ساعتها بس محرّكات البحث بتشوفه كشخص باسمه. ده غير المقعد الشاغر، اللي هو حرفة لسه محدش ماسكها.',
    teamPhoto: 'الصورة الشخصية',
    teamPhotoHint: 'صورة اختيارية — اختارها من مكتبة الوسائط، للمؤسِّسين وللفريق، سواء الاسم منشور أو لأ. طول ما هي فاضية بيعرض الموقع ختم العلامة للأشخاص؛ أما المقعد الشاغر فبيفضل من غير صورة لحد ما تختار واحدة.',
    teamEmail: 'البريد الإلكتروني',
    teamLinkedin: 'رابط لينكدإن',
    copy: 'النص',
    heroImage: 'الصورة الرئيسية',
    year: 'السنة',
    categoryKey: 'التصنيف',
    datasheet: 'ورقة البيانات',
    coordinates: 'الإحداثيات',
    coordinatesHint: 'انقر على الخريطة لتحديد موقع المكتب، أو أدخل خط العرض/الطول (مثلاً من خرائط جوجل). يُستخدم لتحديد موقع المكتب على خريطة المملكة العامة.',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    links: 'الروابط',
    icon: 'الأيقونة',
    iconHint: 'اختر أيقونة من مجموعة العلامة التجارية لهذا القطاع. اتركها فارغة لاستخدام صورة مخصّصة (أدناه) أو الأيقونة الافتراضية.',
    customIcon: 'أيقونة مخصّصة',
    customIconHint: 'اختياري. ارفع صورة لتجاوز قائمة الأيقونات — يُفضّل ملف SVG بسيط بلون واحد ليتناسب مع أيقونات العلامة التجارية.',
    summary: 'الملخّص',
    description: 'الوصف',
    client: 'العميل',
    confidential: 'سرّي',
    confidentialHint:
      'عند التفعيل، يُخفى اسم العميل من الموقع العام؛ ويظل المشروع ظاهراً مع وسم "سرّي".',
    location: 'الموقع',
    shortDescription: 'وصف مختصر',
    relatedProjects: 'المشاريع ذات الصلة',
    relatedProjectsHint: 'المشاريع المعروضة بجانب هذا القطاع في الموقع العام.',
    project: 'مشروع',
    industryHint: 'يصنّف هذا المشروع تحت قطاع في الموقع العام. اختر من قطاعاتك.',
    scope: 'نطاق العمل',
    outcome: 'النتيجة',
    caseDiagram: 'مخطط الحالة',
    caseDiagramHint: 'مخطط أحادي الخط اختياري لدراسة الحالة المميَّزة.',
    flag: 'وسم تحريري',
    flagHint: 'شارة اختيارية تظهر على بطاقة المقالة.',
    readMinutes: 'وقت القراءة (دقائق)',
    publishedAt: 'تاريخ النشر',
    publishedAtHint: 'التاريخ المعروض، مثل 2024-01-10. يختلف عن إجراء النشر في النظام.',
    excerpt: 'مقتطف',
    deck: 'المقدّمة',
    deckHint: 'النص التمهيدي الذي يظهر أسفل العنوان في البطاقة وصفحة المقال.',
    topicTag: 'وسم الموضوع',
    topicTagHint: 'وسم قصير يظهر على البطاقة، مثل «الشبكة الذكية · رؤية 2030».',
    author: 'الكاتب',
    body: 'النص الكامل',
    mark: 'العلامة / الصورة المصغّرة',
    employmentType: 'نوع التوظيف',
    brief: 'نبذة',
    experience: 'الخبرة',
    jobDescription: 'الوصف',
    overview: 'نظرة عامة',
    responsibilities: 'المسؤوليات',
    requirements: 'المتطلبات',
    howToApply: 'كيفية التقديم',
    familyHint: 'العائلة التي ينتمي إليها هذا المنتج. تحدّد الرابط الذي يصفّي عليه الموقع العام.',
    tag: 'وسم',
    spec: 'سطر المواصفات',
    badge: 'شارة',
    badgeHint: 'علامة تحريرية اختيارية على بطاقة المنتج (اتركها فارغة لإخفائها).',
    badgeLabel: 'نص الشارة',
    badgeTone: 'لون الشارة',
    thumbnail: 'صورة مصغّرة',
    thumbnailHint: 'صورة البطاقة. اتركها فارغة للإبقاء على الرسم المرفق لمنتجات الإطلاق.',
    specs: 'المواصفات',
    specLabel: 'اسم المواصفة',
    specValue: 'قيمة المواصفة',
    specUnit: 'الوحدة',
    variants: 'الإصدارات / المدى',
    variantName: 'الاسم',
    variantSpec: 'المواصفة',
    variantNote: 'ملاحظة',
    highlights: 'أبرز النقاط',
    hero: 'القسم الرئيسي',
    heroHeadline: 'العنوان الرئيسي',
    heroSupporting: 'النص الداعم',
    stats: 'إحصاءات رئيسية',
    statValue: 'القيمة',
    statSuffix: 'الوحدة / اللاحقة',
    statLabel: 'التسمية',
    standardsHint: 'معيار واحد في كل سطر، مثل IEC 61439.',
    cta: 'دعوة لاتخاذ إجراء',
    ctaHeading: 'العنوان',
    ctaBody: 'النص',
    ctaPrimary: 'الزر الأساسي',
    ctaLabel: 'نص الزر',
    ctaHref: 'رابط الزر',
  },
  families: {
    eyebrow: 'عائلات المنتجات',
    title: 'عائلات المنتجات',
    newFamily: 'عائلة جديدة',
    createPermission: 'يتطلب إذنًا لإنشاء المحتوى أو تحريره.',
    editPermission: 'يتطلب إذنًا لتحرير المحتوى.',
    colName: 'الاسم',
    colCatalog: 'الكتالوج',
    colOrder: 'الترتيب',
    statusAll: 'جميع الحالات',
    statusDraft: 'مسودة',
    statusInReview: 'قيد المراجعة',
    statusScheduled: 'مجدول',
    statusPublished: 'منشور',
    statusArchived: 'مؤرشف',
    catalogPreview: 'معاينة',
    catalogReady: 'جاهز',
    newTitle: 'عائلة منتجات جديدة',
    untitled: '(بدون عنوان)',
    name: 'الاسم',
    shortName: 'الاسم المختصر',
    tagline: 'العبارة التعريفية',
    slugHint: 'يُنشأ تلقائيًا من الاسم الإنجليزي؛ حرّره للتجاوز.',
    catalogStatus: 'حالة الكتالوج',
    sortOrder: 'ترتيب الفرز',
    summary: 'الملخّص',
    description: 'الوصف',
    heroImage: 'الصورة الرئيسية',
    icon: 'الأيقونة',
    schematic: 'المخطط',
    datasheet: 'ورقة البيانات',
    industries: 'القطاعات',
    industriesHint: 'القطاعات التي تخدمها هذه العائلة. تُستخدم لتصفية القطاعات في الموقع العام وتجميع الصفحة الرئيسية.',
    addIndustry: 'إضافة قطاع',
    remove: 'إزالة',
    noIndustries: 'لا توجد قطاعات مرتبطة بعد.',
    docTitle: 'المحتوى التسويقي',
    highlights: 'أبرز النقاط',
    applications: 'التطبيقات',
    features: 'الميزات',
    standards: 'المعايير',
    tabDetails: 'التفاصيل',
    tabProducts: 'المنتجات',
    tabSeo: 'تحسين محركات البحث',
    tabHistory: 'السجل',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    publishedToast: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    unpublishRedirect: 'تُعيد الصفحة العامة الآن التوجيه إلى /products.',
    siteUpdateBody: 'سيتم تحديث الموقع العام قريبًا.',
    deleteTitle: 'حذف عائلة المنتجات هذه؟',
    deleteDescription: 'ستُحذف العائلة نهائيًا وستُعاد صفحتها إلى /products. لا يمكن التراجع عن هذا الإجراء.',
    readinessHeading: 'قائمة الجاهزية',
    readinessReady: 'جاهزة للنشر',
    readinessMissing: 'ما زال مطلوبًا {{count}}',
    readinessHint: 'تحتاج العائلة "الجاهزة" إلى كل هذه العناصر قبل نشرها، وإلا ستظهر صفحتها العامة ناقصة.',
    readyCard: 'محتوى البطاقة',
    readyDetail: 'محتوى صفحة التفاصيل',
    readyBlocked: 'لا يمكن ضبط هذه العائلة كـ"جاهزة" بعد.',
    readyBlockedDetail: 'املأ الحقول المميَّزة ثم احفظ مرة أخرى.',
    docSchemaError: 'تعذّر تحميل مخطط المحتوى. حدّث الصفحة للمحاولة مرة أخرى.',
    productsHeading: 'المنتجات في هذه العائلة',
    productsHint: 'المنتجات التي تظهر تحت هذه العائلة في الموقع العام.',
    addProduct: '+ إضافة منتج',
    noProducts: 'لا توجد منتجات بعد. أضف منتجًا ليظهر تحت هذه العائلة.',
    deleteBlockedTitle: 'تعذّر الحذف: منتجات منشورة',
    deleteBlockedDescription: 'ما زالت هذه العائلة تحتوي على منتجات منشورة ({{slugs}}). ألغِ نشرها أو انقلها أولًا، ثم احذف العائلة.',
  },
  pages: {
    eyebrow: 'الصفحات',
    title: 'الصفحات',
    newPage: 'صفحة جديدة',
    untitled: '(بدون عنوان)',
    allStatuses: 'جميع الحالات',
    statusDraft: 'مسودة',
    statusScheduled: 'مجدولة',
    statusPublished: 'منشورة',
    statusArchived: 'مؤرشفة',
    slugHint: 'يُنشأ تلقائياً من العنوان الإنجليزي؛ عدّله للتجاوز.',
    keyHint: 'مفتاح داخلي فريد (مثل home أو about).',
    tabSections: 'الأقسام',
    tabDetails: 'التفاصيل',
    tabSeo: 'تحسين محركات البحث (SEO)',
    tabHistory: 'السجل',
    editPermissionRequired: 'يتطلب صلاحية لتحرير المحتوى.',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    publicationUpdatedToast: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    siteUpdateSoon: 'سيتم تحديث الموقع العام قريباً.',
    deletePageTitle: 'حذف هذه الصفحة',
    deletePageDescription: 'ستُحذف الصفحة وجميع أقسامها. لا يمكن التراجع عن هذا الإجراء.',
    deletePageConfirm: 'حذف الصفحة',
    sectionsCount: '{{count}} أقسام',
    addSection: 'إضافة قسم',
    addSectionTitle: 'إضافة قسم',
    addSectionDescription: 'اختر نوع الكتلة. يُنشأ النموذج من مخطط الكتلة.',
    deleteSectionTitle: 'حذف هذا القسم',
    deleteSectionDescription: 'ستُزال هذه الكتلة من الصفحة. لا يمكن التراجع عن هذا الإجراء.',
    sectionDeletedToast: 'تم حذف القسم.',
    sectionAddedToast: 'تمت إضافة القسم.',
    sectionSavedToast: 'تم حفظ القسم.',
    pageUpdateSoon: 'سيتم تحديث الصفحة العامة قريباً.',
    noSectionsYet: 'لا توجد أقسام بعد',
    noSectionsHint: 'استخدم "إضافة قسم" بالأعلى لوضع أول كتلة في هذه الصفحة.',
    dragToReorder: 'اسحب لإعادة الترتيب',
    visible: 'ظاهر',
    hidden: 'مخفي',
    loadingBlockTypes: 'جارٍ تحميل أنواع الكتل…',
    noBlockTypes: 'لا توجد أنواع كتل مسجّلة.',
    addBlockTitle: 'إضافة {{name}}',
    editBlockTitle: 'تحرير {{name}}',
    anchor: 'المرساة',
    anchorHint: 'مرساة HTML اختيارية للربط المباشر (مثل hero ← ‎#hero).',
    visibleOnPublicPage: 'ظاهر في الصفحة العامة',
    blockNames: {
      hero: 'الواجهة الرئيسية',
      rich_text: 'نص منسّق',
      cta: 'دعوة لاتخاذ إجراء',
      faq: 'الأسئلة الشائعة',
      feature_grid: 'شبكة الميزات',
      stats: 'إحصاءات',
      html_embed: 'تضمين HTML',
      articles_showcase: 'عرض المقالات',
      certifications: 'الاعتمادات',
      contact_form: 'نموذج التواصل',
      department_contacts: 'جهات اتصال الأقسام',
      downloads: 'التنزيلات',
      gallery: 'معرض الصور',
      industries_showcase: 'عرض القطاعات',
      jobs_list: 'قائمة الوظائف',
      locations: 'المواقع',
      logos: 'الشعارات',
      map: 'الخريطة',
      process: 'سير العمل',
      product_family_showcase: 'عرض عائلات المنتجات',
      product_showcase: 'عرض المنتجات',
      projects_showcase: 'عرض المشاريع',
      proof: 'نقاط الإثبات',
      quote_form: 'نموذج طلب عرض سعر',
      services: 'الخدمات',
      split_media: 'وسائط مقسّمة',
      steps: 'الخطوات',
      subsidiaries: 'الشركات التابعة',
      team_grid: 'شبكة الفريق',
      testimonials: 'الشهادات',
    },
    blockDescriptions: {
      hero: 'لافتة الصفحة الرئيسية مع عنوان ودعوة لاتخاذ إجراء.',
      rich_text: 'عنوان مع نص منسّق.',
      cta: 'دعوة تتضمن عنوانًا ونصًّا وأزرارًا.',
      faq: 'قائمة بالأسئلة الشائعة.',
      feature_grid: 'شبكة من الميزات أو النقاط البارزة.',
      stats: 'صف من الأرقام الرئيسية.',
      html_embed: 'مقتطف HTML أو تضمين خام.',
      articles_showcase: 'شريط منسّق من المقالات.',
      certifications: 'شارات الاعتماد والمعايير.',
      contact_form: 'نموذج تواصل أو استفسار مضمّن.',
      department_contacts: 'تفاصيل التوجيه لكل قسم.',
      downloads: 'ملفات وأوراق بيانات قابلة للتنزيل.',
      gallery: 'معرض صور.',
      industries_showcase: 'القطاعات المميّزة التي نخدمها.',
      jobs_list: 'قائمة بالوظائف الشاغرة.',
      locations: 'مواقع المكاتب أو المنشآت.',
      logos: 'شعارات الشركاء أو العملاء.',
      map: 'خريطة موقع مضمّنة.',
      process: 'عملية خطوة بخطوة.',
      product_family_showcase: 'عائلات المنتجات المميّزة.',
      product_showcase: 'المنتجات المميّزة.',
      projects_showcase: 'المشاريع المميّزة.',
      proof: 'إحصاءات ومؤشرات مصداقية رئيسية.',
      quote_form: 'نموذج طلب عرض سعر.',
      services: 'نظرة عامة على الخدمات.',
      split_media: 'نص بجانب صورة أو فيديو.',
      steps: 'قائمة مرتّبة من الخطوات.',
      subsidiaries: 'الشركات التابعة للمجموعة.',
      team_grid: 'ملفات أعضاء الفريق.',
      testimonials: 'شهادات العملاء.',
    },
  },
  leads: {
    unknownType: 'نوع عميل محتمل غير معروف.',
    allStatuses: 'كل الحالات',
    allAssignees: 'كل المسؤولين',
    assignee: 'المسؤول',
    assignedToLabel: 'مُسند إلى',
    assignedTo: 'مُسند إلى {{name}}',
    createdAt: 'أُنشئ {{date}}',
    from: 'من',
    to: 'إلى',
    newOnly: 'الجديدة فقط',
    spam: 'غير مرغوب',
    showingSpam: 'عرض السجلات المصنفة كغير مرغوبة.',
    exportCsv: 'تصدير CSV',
    exportTruncatedTitle: 'اقتُطعت النتائج، يرجى تحسين عوامل التصفية.',
    exportTruncatedBody: 'التصدير محدود بحد أقصى {{count}} صف.',
    readPermissionReason: 'يتطلب صلاحية قراءة العملاء المحتملين.',
    managePermissionReason: 'يتطلب صلاحية إدارة العملاء المحتملين.',
    confirmedPage: 'مؤكَّد (الصفحة) {{count}}',
    pendingPage: 'قيد الانتظار (الصفحة) {{count}}',
    colName: 'الاسم',
    colEmail: 'البريد الإلكتروني',
    colCompany: 'الشركة',
    colLocale: 'اللغة',
    colInquiry: 'الاستفسار',
    colCv: 'السيرة الذاتية',
    cvYes: 'سيرة ذاتية ✓',
    cvNo: 'بلا سيرة ذاتية',
    leadDetail: 'تفاصيل العميل المحتمل',
    leadUpdated: 'تم تحديث العميل المحتمل.',
    recordErased: 'تم محو السجل نهائيًا.',
    unassigned: 'غير مُسند',
    yes: 'نعم',
    no: 'لا',
    attachment: 'المرفق',
    file: 'ملف',
    metadataOnly: 'البيانات الوصفية فقط. لا يوجد تنزيل مباشر في هذا الإصدار.',
    manage: 'الإدارة',
    internalNotes: 'ملاحظات داخلية',
    notesReplaceHint: 'يؤدي الحفظ إلى استبدال الملاحظات الحالية.',
    saveChanges: 'حفظ التغييرات',
    dangerZone: 'منطقة الخطر',
    erasureDescription:
      'يؤدي المحو وفق نظام حماية البيانات الشخصية (PDPL) إلى حذف هذا السجل وجميع بياناته الشخصية نهائيًا. هذا الإجراء لا يمكن التراجع عنه ويختلف عن حالتي الأرشفة أو غير المرغوب.',
    erasePermanently: 'محو نهائي',
    confirmEraseTitle: 'محو هذا السجل نهائيًا؟',
    confirmEraseDescription:
      'يؤدي هذا إلى حذف السجل وبياناته الشخصية نهائيًا (محو وفق نظام PDPL). لا يمكن التراجع عنه.',
    cv: 'السيرة الذاتية',
    cvRestricted: 'أصل مقيّد. يتم إنشاء رابط تنزيل جديد في كل مرة.',
    openCv: 'فتح السيرة الذاتية',
    noCvUrl: 'لا يتوفر رابط تنزيل لهذه السيرة الذاتية.',
    fields: {
      fullName: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      company: 'الشركة',
      inquiryType: 'نوع الاستفسار',
      subject: 'الموضوع',
      country: 'الدولة',
      region: 'المنطقة',
      industry: 'القطاع',
      projectLocation: 'موقع المشروع',
      budget: 'الميزانية',
      productFamily: 'عائلة المنتج',
      application: 'التطبيق',
      routedTo: 'موجّه إلى',
      message: 'الرسالة',
      pdplConsent: 'موافقة نظام حماية البيانات',
      productId: 'معرّف المنتج',
      familyId: 'معرّف العائلة',
      quantity: 'الكمية',
      requirements: 'المتطلبات',
      consent: 'الموافقة',
      jobPostingId: 'معرّف إعلان الوظيفة',
      portfolio: 'معرض الأعمال',
      linkedin: 'لينكدإن',
      coverLetter: 'خطاب التقديم',
      status: 'الحالة',
      confirmedAt: 'تاريخ التأكيد',
      unsubscribedAt: 'تاريخ إلغاء الاشتراك',
      source: 'المصدر',
      locale: 'اللغة',
    },
  },
  leadStatus: {
    new: 'جديد',
    in_progress: 'قيد المعالجة',
    reviewing: 'قيد المراجعة',
    shortlisted: 'في القائمة المختصرة',
    responded: 'تم الرد',
    hired: 'تم التوظيف',
    rejected: 'مرفوض',
    closed: 'مغلق',
    spam: 'غير مرغوب',
    archived: 'مؤرشف',
    pending_confirmation: 'بانتظار التأكيد',
    confirmed: 'مؤكَّد',
    unsubscribed: 'أُلغي الاشتراك',
  },
  media: {
    eyebrow: 'الوسائط',
    libraryTitle: 'مكتبة الوسائط',
    kind: 'النوع',
    kindAll: 'جميع الأنواع',
    kindImages: 'الصور',
    kindSvg: 'SVG',
    kindPdf: 'PDF',
    kindDocuments: 'المستندات',
    kindVideo: 'الفيديو',
    searchPlaceholder: 'اسم الملف أو النص البديل أو الوسوم…',
    size: 'الحجم',
    dimensions: 'الأبعاد',
    uploaded: 'تاريخ الرفع',
    checksum: 'المجموع الاختباري',
    altText: 'النص البديل',
    caption: 'وصف توضيحي',
    credit: 'نسبة المصدر',
    folder: 'المجلد',
    tagsLabel: 'الوسوم (مفصولة بفواصل)',
    restrictedAsset: 'أصل مقيّد',
    restrictedHint:
      'تستخدم الأصول المقيّدة روابط موقّعة مسبقًا قصيرة الأجل ولا يتم تخزينها مؤقتًا أبدًا.',
    tabDetails: 'التفاصيل',
    tabUsages: 'الاستخدامات',
    cannotDeleteInUse: 'تعذّر الحذف: لا يزال هذا الأصل قيد الاستخدام.',
    removeOrSwapRefs: 'أزل هذه المراجع أو استبدلها، ثم أعد المحاولة.',
    deleteAssetTitle: 'حذف أصل الوسائط',
    deleteAssetDescription:
      'يُمنع الحذف إذا كان الأصل مُشارًا إليه في أي مكان. ستُعرض أي مراجع مانعة للحذف.',
    notReferencedSafe: 'هذا الأصل غير مُشار إليه في أي مكان. يمكن حذفه بأمان.',
    savedToast: 'تم الحفظ.',
    deletedToast: 'تم الحذف.',
    chooseMedia: 'اختيار وسائط',
    uploadedToast: 'تم الرفع.',
    uploadedToastDetail: 'الأصل جاهز للاستخدام.',
    unsupportedType: 'نوع ملف غير مدعوم: ‎.{{ext}}',
    exceedsLimit: 'يتجاوز الملف الحد الأقصى البالغ {{limit}}.',
    unsafeSvgTitle: 'تعذّر تنظيف ملف SVG هذا بأمان.',
    unsafeSvgDetail: 'يحتوي على محتوى نشط (نصوص برمجية أو معالجات أحداث) لا يمكن إزالته. أعد تصديره كمتجه بسيط أو استخدم صورة PNG.',
    dragFileHere: 'اسحب ملفًا إلى هنا، أو',
    chooseFile: 'اختيار ملف',
    acceptedHint: 'صور، SVG، PDF، DOC، فيديو · بحد أقصى {{limit}}',
    altTextEnglish: 'النص البديل (الإنجليزية)',
    altTextRequiredHint: 'مطلوب قبل أن يمكن الإشارة إلى الصورة.',
    upload: 'رفع',
  },
  settings: {
    eyebrow: 'الإعدادات',
    pageTitle: 'إعدادات الموقع والواجهة',
    forbidden: 'تتم إدارة إعدادات الموقع من قبل المسؤولين.',
    nav: {
      settings: 'الإعدادات',
      strings: 'نصوص الواجهة',
      navigation: 'التنقل',
      redirects: 'إعادة التوجيه',
      directory: 'دليل جهات الاتصال',
      countries: 'الدول',
      pageCopy: 'محتوى الصفحات',
    },
    general: {
      savedTitle: 'تم حفظ الإعدادات.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      localesHeading: 'اللغات',
      defaultLocale: 'اللغة الافتراضية',
      enabledLocales: 'اللغات المفعّلة',
      localeEn: 'الإنجليزية (en)',
      localeAr: 'العربية (ar)',
      requireAr: 'اشتراط الترجمة العربية عند النشر',
      requireArHint: 'منع نشر المحتوى الذي تنقصه الترجمة العربية.',
      maintenanceHeading: 'وضع الصيانة',
      maintenanceToggle: 'تفعيل وضع الصيانة على الموقع العام',
      maintenanceHint:
        'يستبدل جميع صفحات الموقع العام بإشعار ودّي بأن الموقع «قيد الصيانة» حتى لا يرى الزوار محتوى غير مكتمل أو تجريبي. يواصل المحررون عملهم في لوحة التحكم، ويسري التغيير خلال دقيقة.',
      brandIdentityHeading: 'الهوية اللفظية',
      brandIdentityDescription:
        'العلامة اللفظية والعبارة التعريفية والرابط الأساسي التي يعرضها الموقع العام في واجهته.',
      wordmark: 'العلامة اللفظية',
      wordmarkHint: 'العلامة اللفظية للموقع، مثل Y/DIRECTION.',
      wordmarkAr: 'العلامة اللفظية (العربية)',
      wordmarkArHint: 'العلامة اللفظية بالخط العربي المعروضة على ‏/ar.',
      tagline: 'العبارة التعريفية',
      taglineHint: 'السطر القصير أسفل العلامة اللفظية — صوت الهامش الإنساني.',
      siteUrl: 'رابط الموقع',
      siteUrlHint: 'الرابط العام الأساسي، مثل https://ydirection.co.',
      brandHeading: 'أصول الهوية البصرية',
      brandDescription:
        'معرّفات أصول الوسائط الخاصة بواجهة الموقع العام. اتركها فارغة لاستخدام إعداد القالب الافتراضي.',
      logoAssetId: 'معرّف أصل الشعار',
      faviconAssetId: 'معرّف أصل أيقونة الموقع',
      ogImageAssetId: 'معرّف أصل صورة المشاركة الافتراضية',
      headScriptsHeading: 'نصوص الترويسة البرمجية',
      headScriptsWarning:
        'تنبيه: يُدرَج هذا الكود حرفيًا في ترويسة كل صفحة عامة. قد يؤدي الكود غير الصالح أو الضار إلى تعطيل الموقع المباشر أو الإضرار به. الصق فقط مقتطفات التحليلات أو التحقق الموثوقة.',
      headScriptsLabel: 'الكود المُدرَج في ترويسة الموقع العام',
      saveButton: 'حفظ الإعدادات',
    },
    navigation: {
      menuHeader: 'الترويسة',
      menuFooter: 'التذييل',
      menuMobile: 'الجوال',
      menuLegal: 'القانوني',
      linkInternal: 'داخلي (مسار)',
      linkExternal: 'خارجي (رابط)',
      savedTitle: 'تم حفظ التنقل.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      itemDeleted: 'تم حذف العنصر.',
      errLabelRequired: 'التسمية الإنجليزية مطلوبة.',
      errSlugRequired: 'مسار الوجهة مطلوب للروابط الداخلية.',
      errUrlRequired: 'الرابط مطلوب للروابط الخارجية.',
      menuLabel: 'القائمة',
      newItem: 'عنصر جديد',
      deleteChildrenNote: 'حذف عنصر يؤدي أيضًا إلى إزالة جميع عناصره الفرعية.',
      moveUp: 'تحريك لأعلى',
      moveDown: 'تحريك لأسفل',
      untitled: '(بدون عنوان)',
      childTag: 'فرعي',
      hiddenTag: 'مخفي',
      editItem: 'تعديل عنصر التنقل',
      newItemTitle: 'عنصر تنقل جديد',
      fieldLabel: 'التسمية',
      linkType: 'نوع الرابط',
      targetSlug: 'مسار الوجهة',
      targetSlugHint: 'المسار على الموقع العام، مثل ‏/about.',
      url: 'الرابط',
      urlHint: 'رابط خارجي كامل، مثل ‏https://example.com.',
      openInNewTab: 'فتح في علامة تبويب جديدة',
      visible: 'ظاهر',
      deleteTitle: 'حذف عنصر التنقل؟',
      deleteDescription: 'سيؤدي ذلك أيضًا إلى إزالة أي عناصر فرعية تحته.',
    },
    contact: {
      savedTitle: 'تم حفظ جهة الاتصال.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف جهة الاتصال.',
      errKeyRequired: 'المفتاح مطلوب.',
      errLabelRequired: 'التسمية الإنجليزية مطلوبة.',
      errEmailRequired: 'البريد الإلكتروني مطلوب.',
      colLabel: 'التسمية',
      colEmail: 'البريد الإلكتروني',
      colPhone: 'الهاتف',
      colVisible: 'ظاهر',
      colOrder: 'الترتيب',
      visibleTag: 'ظاهر',
      hiddenTag: 'مخفي',
      newContact: 'جهة اتصال جديدة',
      editContact: 'تعديل جهة الاتصال',
      fieldLabel: 'التسمية',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      sla: 'اتفاقية مستوى الخدمة',
      slaHint: 'التزام بزمن الاستجابة يُعرَض للزوار، مثل خلال يومي عمل.',
      sortOrder: 'ترتيب الفرز',
      visible: 'ظاهر',
      deleteTitle: 'حذف جهة الاتصال؟',
      deleteDescription: 'إزالة "{{key}}" من الدليل.',
    },
    countries: {
      savedTitle: 'تم حفظ الدولة.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      defaultUpdatedTitle: 'تم تحديث الدولة الافتراضية.',
      deleted: 'تم حذف الدولة.',
      errCode: 'استخدم رمز دولة ISO من حرفين.',
      colCode: 'الرمز',
      colDefault: 'الافتراضية',
      colOrder: 'الترتيب',
      defaultTag: 'افتراضية',
      setDefault: 'تعيين كافتراضية',
      newCountry: 'دولة جديدة',
      editCountry: 'تعديل الدولة',
      isoCode: 'رمز ISO',
      isoCodeHint: 'رمز ISO 3166-1 من حرفين، مثل SA.',
      sortOrder: 'ترتيب الفرز',
      setAsDefault: 'التعيين كافتراضية',
      setAsDefaultHint: 'يجعل هذه الدولة الافتراضية الوحيدة.',
      deleteTitle: 'حذف الدولة؟',
      deleteDescription: 'إزالة "{{code}}" من السجل.',
    },
    redirects: {
      status301: '301 نُقل بشكل دائم',
      status302: '302 موجود',
      status307: '307 مؤقت',
      status308: '308 دائم',
      savedTitle: 'تم حفظ إعادة التوجيه.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف إعادة التوجيه.',
      errFromPath: 'يجب أن يبدأ المسار المصدر بـ "/".',
      errToRequired: 'الوجهة مطلوبة.',
      errToDiffer: 'يجب أن تختلف الوجهة عن المصدر.',
      errStatus: 'اختر حالة إعادة توجيه صالحة.',
      colFrom: 'من',
      colTo: 'إلى',
      colActive: 'نشط',
      colHits: 'الزيارات',
      activeTag: 'نشط',
      inactiveTag: 'غير نشط',
      newRedirect: 'إعادة توجيه جديدة',
      editRedirect: 'تعديل إعادة التوجيه',
      dialogDescription:
        'يتم الإدراج أو التحديث حسب المسار المصدر. تعديل المسار المصدر لإعادة توجيه قائمة يُنشئ مدخلًا جديدًا.',
      fromPath: 'المسار المصدر',
      fromPathHint: 'يجب أن يبدأ بشرطة مائلة، مثل ‏/old-page.',
      toPath: 'المسار الوجهة',
      toPathHint: 'مسار الوجهة أو رابط كامل.',
      active: 'نشط',
      deleteTitle: 'حذف إعادة التوجيه؟',
      deleteDescription: 'إزالة إعادة التوجيه من {{from}}.',
    },
    pageCopy: {
      savedTitle: 'تم الحفظ.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      selectPrompt: 'اختر نطاقًا لتعديل محتواه.',
      searchPlaceholder: 'تصفية النطاقات…',
      updatedAt: 'حُدّث {{time}}',
      // محرر المحتوى
      notObject: 'يجب أن يكون المستند كائن JSON.',
      emptyGroup: 'لا توجد حقول.',
      emptyList: 'لا توجد عناصر.',
      itemLabel: 'العنصر {{index}}',
      booleanLabel: 'مُفعّل',
      emptyTextPlaceholder: 'أدخل النص…',
      unsaved: 'تغييرات غير محفوظة',
      allSaved: 'تم حفظ جميع التغييرات',
      // تغطية العربية
      arabicComplete: 'اكتملت الترجمة العربية',
      arabicCompleteHintReady: 'جميع الحقول تحتوي على نص عربي.',
      arabicCompleteHintPending: 'لا يزال {{count}} حقل/حقول بدون عربية.',
      arCoverage: 'تغطية العربية',
      coverageCount: '{{translated}} / {{total}} مُترجَم',
      noFields: 'لا توجد حقول قابلة للترجمة',
      // الاستخدامات (فهرس عكسي ← الصفحات المستهلِكة)
      usagesHeading: 'يظهر في',
      usagesLoading: 'جارٍ التحقق من مواضع ظهور هذا المحتوى…',
      usedByCount: '{{count}} صفحة',
      unused: 'غير مُستخدَم',
      unusedHint: 'لا توجد صفحة تشير إلى هذا النطاق بعد.',
      viaNamespaces: 'مشترك',
      viaCta: 'دعوة لإجراء',
    },
    strings: {
      savedTitle: 'تم حفظ النص.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف النص.',
      errNamespaceRequired: 'النطاق مطلوب.',
      errKeyRequired: 'المفتاح مطلوب.',
      errValueRequired: 'القيمة الإنجليزية مطلوبة.',
      colNamespace: 'النطاق',
      missingAr: 'العربية ناقصة',
      newString: 'نص جديد',
      editString: 'تعديل النص',
      namespace: 'النطاق',
      value: 'القيمة',
      deleteTitle: 'حذف النص؟',
      deleteDescription: 'إزالة "{{id}}" من واجهة الموقع.',
    },
  },
  users: {
    eyebrow: 'الإدارة',
    title: 'المستخدمون',
    newUser: 'مستخدم جديد',
    forbidden: 'تحتاج إلى صلاحية إدارة المستخدمين لعرض هذه المنطقة.',
    sessionNote: 'تؤدي إعادة تعيين كلمة المرور أو إلغاء تنشيط المستخدم إلى إبطال جلساته النشطة فورًا.',
    columns: {
      email: 'البريد الإلكتروني',
      name: 'الاسم',
      role: 'الدور',
      locale: 'اللغة',
      status: 'الحالة',
      lastLogin: 'آخر تسجيل دخول',
      mfa: 'المصادقة الثنائية',
    },
    status: {
      active: 'نشط',
      inactive: 'غير نشط',
    },
    mfa: {
      enabled: 'مفعّلة',
    },
    roles: {
      admin: 'مسؤول',
      editor: 'محرّر',
      author: 'كاتب',
      translator: 'مترجم',
      sales: 'مبيعات',
      viewer: 'مشاهد',
    },
    locales: {
      en: 'الإنجليزية',
      ar: 'العربية',
    },
    fields: {
      email: 'البريد الإلكتروني',
      name: 'الاسم',
      role: 'الدور',
      locale: 'اللغة',
      active: 'نشط',
      initialPassword: 'كلمة المرور الأولية',
      resetPassword: 'إعادة تعيين كلمة المرور',
      resetPasswordPlaceholder: 'اتركه فارغًا للإبقاء على الحالية',
    },
    hints: {
      minChars: 'عشرة أحرف على الأقل.',
      deactivate: 'يؤدي إلغاء التنشيط إلى إبطال جلسات هذا المستخدم.',
      resetPassword: 'عشرة أحرف على الأقل. تؤدي إعادة التعيين إلى إبطال جلسات هذا المستخدم.',
    },
    create: {
      title: 'مستخدم جديد',
      description: 'أنشئ مستخدمًا إداريًا. يمكنه تسجيل الدخول باستخدام كلمة المرور الأولية التي تحددها هنا.',
      submit: 'إنشاء المستخدم',
    },
    edit: {
      title: 'تعديل {{name}}',
      save: 'حفظ التغييرات',
    },
    delete: {
      title: 'حذف {{name}}؟',
      description:
        'يؤدي هذا إلى حذف {{email}} حذفًا مبدئيًا وإبطال جلساته النشطة. يمنع الخادم حذف آخر مسؤول نشط. لا يمكن التراجع عن هذا الإجراء من هنا.',
      confirm: 'حذف المستخدم',
    },
    toasts: {
      created: 'تم إنشاء المستخدم {{email}}.',
      updated: 'تم تحديث المستخدم {{email}}.',
      deleted: 'تم حذف المستخدم {{email}}. تم إبطال جلساته.',
    },
    errors: {
      emailInUse: 'عنوان البريد الإلكتروني هذا مستخدم بالفعل.',
      lastAdmin: 'لا يمكن تخفيض رتبة آخر مسؤول نشط أو تعطيله.',
    },
  },
  audit: {
    eyebrow: 'سجل التدقيق',
    title: 'سجل التدقيق',
    forbidden: 'ليس لديك إذن لعرض سجل التدقيق.',
    colTime: 'الوقت',
    colActor: 'المنفِّذ',
    colAction: 'الإجراء',
    colEntity: 'الكيان',
    colIp: 'عنوان IP',
    filterEntityType: 'نوع الكيان',
    filterEntityId: 'معرّف الكيان',
    filterActorId: 'معرّف المنفِّذ',
    filterFrom: 'من',
    filterTo: 'إلى',
    entryTitle: 'سجل التدقيق',
    detailUserAgent: 'وكيل المستخدم',
    detailDiff: 'الفروقات',
  },
  account: {
    eyebrow: 'الحساب',
    title: 'حسابك',
    profile: 'الملف الشخصي',
    name: 'الاسم',
    interfaceLanguage: 'لغة الواجهة',
    saveProfile: 'حفظ الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    profileUpdated: 'تم تحديث الملف الشخصي.',
    passwordChanged: 'تم تغيير كلمة المرور. تم تسجيل خروج جلساتك الأخرى.',
    mfaTitle: 'المصادقة الثنائية',
    mfaEnabledHint: 'المصادقة الثنائية مفعّلة. يتطلب تسجيل الدخول رمزًا من تطبيق المصادقة لديك.',
    mfaSetupHint: 'أضِف رمزًا مؤقتًا يُستخدم لمرة واحدة (TOTP) لطبقة أمان إضافية.',
    beginEnrollment: 'بدء التسجيل',
    qrAlt: 'رمز الاستجابة السريعة للمصادقة الثنائية',
    enterSecret: 'أو أدخل هذا الرمز السري: {{secret}}',
    code6: 'رمز مكوّن من 6 أرقام',
    code6Disable: 'رمز مكوّن من 6 أرقام للتعطيل',
    verifyAndEnable: 'التحقق والتفعيل',
    disableMfa: 'تعطيل المصادقة الثنائية',
    mfaEnabledToast: 'تم تفعيل المصادقة الثنائية.',
    mfaDisabledToast: 'تم تعطيل المصادقة الثنائية.',
    mfaBadge: 'المصادقة الثنائية',
    strengthTooWeak: 'ضعيفة جدًا',
    strengthWeak: 'ضعيفة',
    strengthFair: 'مقبولة',
    strengthGood: 'جيدة',
    strengthStrong: 'قوية',
  },
  search: {
    placeholder: 'ابحث في المحتوى ونصوص الموقع…',
    ariaLabel: 'البحث الشامل',
    searching: 'جارٍ البحث…',
    noResults: 'لا توجد نتائج.',
    entity: {
      page: 'صفحة',
      page_copy: 'محتوى الصفحات',
      family: 'عائلة',
      product_family: 'عائلة',
      industry: 'قطاع',
      project: 'مشروع',
      article: 'مقالة',
      job: 'وظيفة',
      product: 'منتج',
      location: 'موقع',
      subsidiary: 'شركة تابعة',
    },
  },
  preview: {
    dialogTitle: 'معاينة المسودة',
    iframeTitle: 'معاينة',
  },
  revisions: {
    restore: 'استعادة',
    restoredToast: 'تمت الاستعادة كمراجعة جديدة.',
    restoredToastDesc: 'تُركت حالة النشر دون تغيير.',
    restoreDialogTitle: 'استعادة المحتوى كمراجعة جديدة',
    restoreDialogDesc:
      'يؤدي هذا إلى إعادة تطبيق الحقول التحريرية للمراجعة المحددة وإنشاء مراجعة جديدة. تُترك حالة النشر دون تغيير.',
  },
  publish: {
    publishNow: 'نشر الآن',
    reschedule: 'إعادة جدولة',
    scheduleDialogTitle: 'جدولة النشر',
    scheduleDialogDesc: 'يقوم مؤقّت الخادم بالنشر في الوقت المحدد.',
    publishAt: 'نشر في',
  },
  seo: {
    metaTitle: 'عنوان الميتا',
    metaDescription: 'وصف الميتا',
    keywords: 'الكلمات المفتاحية',
    socialImage: 'صورة التواصل الاجتماعي',
    canonicalUrl: 'الرابط الأساسي (Canonical)',
    noIndex: 'إخفاء من محركات البحث (noindex)',
  },
};

export default ar;
